// src/utils/presensiApi.js
// Self-contained presensi helpers (no date-fns dependency)
import { apiFetch } from "./wkCommon";
import { getUser } from "./auth";


export async function fetchAreas() {
  const resp = await apiFetch(`/api/areas?populate=*`);
  return resp?.data ?? resp;
}

export async function fetchUmatsMinimal() {
  const q = [
    "fields[0]=umatID",
    "fields[1]=fullName",
    "fields[2]=chineseName",
    "fields[3]=pinyinName",
    "fields[4]=nickName",
    "fields[5]=gender",
    "populate[0]=area",
    "populate[1]=profilepic"
  ].join("&");
  const resp = await apiFetch(`/api/umats?${q}`);
  return resp?.data ?? resp;
}
// Catatan: umumnya gambar/media ada di profilepic (object) 

export async function fetchFotangExternals() {
  const resp = await apiFetch(`/api/fotang-externals?populate=external_people`);
  return resp?.data ?? resp;
}
// Catatan: fotang_externals punya relasi external_people (lihat skema). 
// Jika butuh semua field, gunakan populate=*; 
// untuk flatten ambil d.attributes dan tiap d.attributes.external_people.data. :contentReference[oaicite:0]{index=0}

export async function fetchExternalPersons() {
  const resp = await apiFetch(`/api/external-people?populate=*`);
  return resp?.data ?? resp;
}
// Catatan: external-person biasanya memiliki field kontak/nama; 

export async function fetchAgendaById(agendaId) {
  if (!agendaId) throw new Error("agendaId required");
  const q = [
    "populate[0]=events",
    "populate[1]=events.participants",
    "populate[2]=events.participants.umat.profilepic",
    "populate[3]=events.participants.umat.area",
    "populate[4]=events.participants.external_person",
    "populate[5]=events.participants.external_person.fotang_external",
    "populate[6]=events.participants.non_umat_pre_registration",
    "populate[7]=agenda_book",
    "populate[8]=agenda_pre_registrations",
    "populate[9]=area",
    "populate[10]=agenda_pre_reg_form"
  ].join("&");
  const resp = await apiFetch(`/api/agendas/${encodeURIComponent(agendaId)}?${q}`);
  return resp?.data ?? resp;
}
